/**
 * @desc 导入账单补充信息
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/importBillInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
